import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';
import {
  isBoundarySelectActive,
  isBoundarySelectModalOpen, isBoundarySelectQuickEditCustomBoundary,
} from './boundarySelect.state';

export const boundarySelectSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundarySelect;
export const useBoundarySelectSelector = () => useSelector(boundarySelectSelector);

const boundarySelectIsLassoLoadingSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundarySelect.isLassoSelectLoading;
export const useBoundarySelectIsLassoLoadingSelector = () => useSelector(boundarySelectIsLassoLoadingSelector);

const boundarySelectActiveSelector = (state: AppState) => {
  const { boundarySelect } = state.frontendState.mapTools.boundary;
  return isBoundarySelectActive(boundarySelect) ? boundarySelect : null;
};
export const useBoundarySelectActiveSelector = () => useSelector(boundarySelectActiveSelector);

export const boundarySelectModalOpenSelector = (state: AppState) => {
  const { boundarySelect } = state.frontendState.mapTools.boundary;
  return isBoundarySelectModalOpen(boundarySelect) ? boundarySelect : null;
};
export const useBoundarySelectModalOpenSelector = () => useSelector(boundarySelectModalOpenSelector);

const boundarySelectSelectedBucketIdSelector = (state: AppState) => {
  const boundarySelectState = state.frontendState.mapTools.boundary.boundarySelect;
  return isBoundarySelectQuickEditCustomBoundary(boundarySelectState) ? boundarySelectState.selectionModeData.selectedBucketId : null;
};
export const useBoundarySelectSelectedBucketIdSelector = () => useSelector(boundarySelectSelectedBucketIdSelector);
